export default "__VITE_ASSET__cd75a4cd__"